<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />
        
        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span>403 - Forbidden</span>
            </div>
        </div>
        <!-- top-header end-->
        
        <!-- wrapper  -->	
        <div id="wrapper">
            <!-- content-holder  -->	
            <div class="content-holder" data-pagetitle="403">
                <!-- Navigation -->
                <Navigation />
                
                <!-- content-->
                <div class="content full-height">
                    <div class="column-wrap">
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>
                            
                            <section class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>403 <strong>Access Forbidden</strong></h2>
                                        <p>You don't have permission to access this resource.</p>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    
                                    <div class="column-wrapper_text fl-wrap text-center">
                                        <div class="error-code">
                                            <h1>403</h1>
                                        </div>
                                        <p>Sorry, but you don't have access to this page or resource.</p>
                                        <router-link to="/" class="btn float-btn">
                                            <span>Back to Homepage</span>
                                        </router-link>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <!-- content end  -->
                
                <div class="limit-box fl-wrap"></div>
                
                <!-- Footer -->
                <AppFooter />
                
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
        
        <!-- cursor-->
        <div class="element">
            <div class="element-item"></div>
        </div>
        <!-- cursor end-->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'Forbidden',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
        }
    },
    mounted() {
        document.title = '403 - Access Forbidden'
        // Initialize theme
        this.$nextTick(() => {
            if (this.$initTheme) {
                this.$initTheme()
            }
        })
    }
}
</script>

<style scoped>
.error-code h1 {
    font-size: 150px;
    font-weight: 700;
    margin: 30px 0;
    color: #ccc;
}

.text-center {
    text-align: center;
}
</style>
